import React, { useState } from "react";
import hotelData from "../fakeData/hotelData";
import Map from "./Map";
import { useParams } from "react-router-dom";
import star from "../../images/Icon/star_1_.png";

const Hotels = () => {
    const { id } = useParams();

    // from user input
    // const [hotels, setHotels] = useState([]);

    // to show hotels directly
    const hotels = hotelData.filter((hotel) => hotel.category === id);

    // const handleSearch = (event) => {
    //   event.preventDefault();
    //   const searchText = event.target.value.toLowerCase();
    //   const matched = hotelData.filter(
    //     (item) =>
    //       item.category.toLowerCase().includes(searchText) ||
    //       item.title.toLowerCase().includes(searchText)
    //   );
    //   setHotels(matched);
    // };

    // const searchHotel = (
    //   <input
    //     className="form-control mt-3 w-75"
    //     onKeyUp={handleSearch}
    //     type="text"
    //     placeholder="Search your hotel by place name"
    //   />
    // );

    return (
        <>
            <div className="container-fluid mt-4">
                <div className="row">
                    <div className="col-10 col-md-6 col-lg-6">
                        {hotels.map((hotel) => (
                            <div className="row mt-4 d-flex justify-content-between">
                                <img className="img-fluid w-50 ml-2 col-md-5 h-50 mx-auto" src={hotel.img} alt="" />
                                <div className="col-md-5 mx-auto">
                                    <h3>{hotel.title}</h3>
                                    <div className="d-flex justify-content-between my-4">
                                        <div className="d-flex">
                                            <img className="h-75" src={star} alt="" />
                                            <h4 className="font-weight-bold">{hotel.star}</h4>
                                        </div>
                                        <div>
                                            <h4 className="ml-auto">${hotel.price}/night</h4>
                                        </div>
                                    </div>
                                    <p style={{ height: "200px", overflowY: "scroll" }}>{hotel.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <Map id={id} />
                </div>
            </div>
        </>
    );
};

export default Hotels;
